<template>
    <div class="real-name-box"> 
		<div class="page-btns-box">
		    <el-button
		        type="primary"
		        icon="el-icon-circle-plus"
		        @click="nicknameVisible = true"
		        v-if="$utils.have('/nicknameDisabled/add')"
		        size="small"
		        >新增昵称</el-button>		    
		</div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >                
                <el-table-column label="禁用昵称" prop="name"></el-table-column>
                <el-table-column label="添加时间" prop="createTime" ></el-table-column>                
                <el-table-column fixed="right" label="操作" width="150" >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            v-if="$utils.have('/nicknameDisabled/del')"
                            icon="el-icon-s-management"
                             @click="del(scope.row.id)"
                            >删除</el-button>                       
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
        <addnickname  :nicknameVisible.sync="nicknameVisible" @update="getDataList()"  ref="Addnickname" />
    </div>
</template>
<script>
import Addnickname from './components/addnickname';
export default {
   components: {
       Addnickname      
   },
    data() {
        return {
            data: null,
            dataList: null,
            params: {               
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0])                
            },           
            listLoading: false,
			nicknameVisible:false
           
        };
    },   
    computed: {
             
    },
    created(){
       
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;            
            this.$request({
                url: "/nicknameDisabled/list",
                method: "POST",
                params:this.params
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        const data = result.result || [];                        
                        this.dataList = result.result;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
       //删除
       del(id){
           const _msg = '删除后用户可以使用该昵称进行注册确认删除该昵称?';
           this.$confirm(_msg, '提示', {
               type: 'warning',
               center: true,
               closeOnClickModal: false
           }).then(() => {
               this.listLoading = true;
               this.$request({
                   url: '/nicknameDisabled/del',
                   method: 'POST',
                   params: {id:id}
               }).then(res => {
                   const { state, msg } = res.data;
                   if( state == 1 ){
                       this.getDataList();
                   }else{
                       this.$message.error(msg || '请求失败');
                   }
               }).catch(() => {
                   this.$message.error('请求错误');
               }).finally(() => {
                   this.listLoading = false;
               });
           })
       },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        }        
    }
};
</script>
<style scoped lang="scss">

</style>
